import { useIntl } from 'react-intl';
import { MetabaseError } from './MetabaseError';

const MetabaseReportError = () => {
  const intl = useIntl();

  return (
    <MetabaseError
      title={intl.formatMessage({
        id: 'containers.errorPage.metabase-report-error.title',
      })}
      description={intl.formatMessage({
        id: 'containers.errorPage.metabase-report-error.text',
      })}
    />
  );
};

export { MetabaseReportError };
